module.exports = __webpack_public_path__ + "img/balkongelaender03.8b84ab8b.jpg";